class health_insurance {
  constructor() {
    const WEBDOCHEALTHINSDAILY1 = "WEBDOCHEALTHINSDAILY1";
    const WEBDOCHEALTHINSDAILY2 = "WEBDOCHEALTHINSDAILY2";
    const WEBDOCHEALTHINSDAILY3 = "WEBDOCHEALTHINSDAILY3";
    const WEBDOCHEALTHINSDAILY4 = "WEBDOCHEALTHINSDAILY4";
    const WEBDOCHEALTHINSDAILY5 = "WEBDOCHEALTHINSDAILY5";
    this.items = [
      {
        serviceId: 1,
        pid: WEBDOCHEALTHINSDAILY1,
        name: "WebdocHealthInsDaily1",
        serviceName:"Health Insurance",
        badge: "Silver",
        coverage: "240,000",
        price:"3.5",
        bgColorClass: "bg-info",
        description: `<p><strong>Health Insurance </strong>is an exciting product that provides good value to Jazz customers who get financial protection in case of In-Patient hospitalization, providing relief in the form of cash for medical and out-of-pocket expenses.</p>
<ul>
<li><strong>Waiting Period:</strong> 7 days</li>
<li><strong>Hospital Coverage (30 days): </strong>Up to PKR 90,000</li>
<li><strong>Accidental Hospitalization (30 days): </strong>Up to PKR 150,000</li>
</ul>

<p><strong>Claims</strong></p>
<ul>
<li>Make your claim within 30 (thirty) days from the date of discharge from the hospital</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>Hospital discharge slip & other documents might be required </li>
</ul>`,
        type: "insurance",
      },
      {
        serviceId: 2,
        pid: WEBDOCHEALTHINSDAILY2,
        name: "WebdocHealthInsDaily2",
        serviceName:"Health Insurance",
        badge: "Gold",
        coverage: "480,000",
        price:"7.0",
        bgColorClass: "bg-warning",
        description: `<p><strong>Health Insurance </strong>is an exciting product that provides good value to Jazz customers who get financial protection in case of In-Patient hospitalization, providing relief in the form of cash for medical and out-of-pocket expenses.</p>
<ul>
<li><strong>Waiting Period:</strong> 7 days</li>
<li><strong>Hospital Coverage (30 days): </strong>Up to PKR 180,000</li>
<li><strong>Accidental Hospitalization (30 days): </strong>Up to PKR 300,000</li>
</ul>

<p><strong>Claims</strong></p>
<ul>
<li>Make your claim within 30 (thirty) days from the date of discharge from the hospital</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>Hospital discharge slip & other documents might be required </li>
</ul>`,
        type: "insurance",
      },
      {
        serviceId: 3,
        pid: WEBDOCHEALTHINSDAILY3,
        name: "WebdocHealthInsDaily3",
        serviceName:"Health Insurance",
        badge: "Platinum",
        coverage: "720,000",
        price:"11.0",
        bgColorClass: "bg-info",
        description: `<p><strong>Health Insurance </strong>is an exciting product that provides good value to Jazz customers who get financial protection in case of In-Patient hospitalization, providing relief in the form of cash for medical and out-of-pocket expenses.</p>
<ul>
<li><strong>Waiting Period:</strong> 7 days</li>
<li><strong>Hospital Coverage (30 days): </strong>Up to PKR 270,000</li>
<li><strong>Accidental Hospitalization (30 days): </strong>Up to PKR 450,000</li>
</ul>

<p><strong>Claims</strong></p>
<ul>
<li>Make your claim within 30 (thirty) days from the date of discharge from the hospital</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>Hospital discharge slip & other documents might be required </li>
</ul>`,
        type: "insurance",
      },
//       {
//         serviceId: 4,
//         pid: WEBDOCHEALTHINSDAILY4,
//         name: "WebdocHealthInsDaily4",
//         serviceName:"Webdoc Health Insurance",
//         badge: "Gold",
//         coverage: "32,000",
//         price:"14.5",
//         bgColorClass: "bg-warning",
//         description: `<p><strong>Health Insurance </strong>is an exciting product that provides good value to Jazz customers who get financial protection in case of In-Patient hospitalization, providing relief in the form of cash for medical and out-of-pocket expenses.</p>
// <ul>
// <li><strong>Total Insurance Cover: </strong>Up to PKR 32,000</li>
// <li><strong>Insurance Period:</strong> 30 days</li>
// <li><strong>Daily Hospital Benefit: </strong>Up to PKR 12,000</li>
// <li><strong>Daily Accidental Hospitalization: </strong>Up to PKR 20,000</li>
// </ul>

// <p><strong>Claims</strong></p>
// <ul>
// <li>Settled directly with the claimants within 3 working days of document submission</li>
// <li>Hospital discharge slip & other documents might be required </li>
// </ul>`,
//         type: "insurance",
//       },
//       {
//         serviceId: 5,
//         pid: WEBDOCHEALTHINSDAILY5,
//         name: "WebdocHealthInsDaily5",
//         serviceName:"Webdoc Health Insurance",
//         badge: "Platinum",
//         coverage: "40,000/-",
//         price:"18.0",
//         bgColorClass: "bg-warning",
//         description: `<p><strong>Health Insurance </strong>is an exciting product that provides good value to Jazz customers who get financial protection in case of In-Patient hospitalization, providing relief in the form of cash for medical and out-of-pocket expenses.</p>
// <ul>
// <li><strong>Total Insurance Cover: </strong>Up to PKR 40,000</li>
// <li><strong>Insurance Period:</strong> 30 days</li>
// <li><strong>Daily Hospital Benefit: </strong>Up to PKR 15,000</li>
// <li><strong>Daily Accidental Hospitalization: </strong>Up to PKR 25,000</li>
// </ul>

// <p><strong>Claims</strong></p>
// <ul>
// <li>Settled directly with the claimants within 3 working days of document submission</li>
// <li>Hospital discharge slip & other documents might be required </li>
// </ul>`,
//         type: "insurance",
//       }
    ];
  }

  getAllItems() {
    return this.items;
  }
}

export default health_insurance;
